/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import {
    func, bool,
} from 'prop-types';
import ItemImage from '../ItemImage/ItemImage';

import {
    getOrderTotalProduct,
    getCartData,
    getTotalItemInCart,
} from '../../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import { getFeatureFlags } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import DeleteItemButton from './DeleteItemButton';
import { setCurrencyFormatforTotalOrder } from '../Helper/Helper';
import ContinueShoppingButton from './ContinueShoppingButton';

const useStyles = makeStyles((theme) => ({
    containerDrawer: {
        width: '492px',
        [theme.breakpoints.down(1366)]: {
            width: '461px',
        },
        [theme.breakpoints.down(1024)]: {
            width: '380px',
        },
        [theme.breakpoints.down(415)]: {
            width: '100%',
        },
    },
    modalDrawer: {
        zIndex: '9991 !important',
    },
    list: {
        maxHeight: 'calc(100% - 190px)',
        minHeight: 'calc(100% - 190px)',
        overflowY: 'auto',
        padding: '0px',
        display: 'flex',
        flexDirection: 'column',
        margin: '0rem 3px 0px 0px',
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
        },
        '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
            width: '5px',
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: 'transparent',
        },
        scrollbarColor: 'rgba(156, 156, 156, 1) transparent',  /* Works on Firefox */
    },
    listContainer: {
        maxHeight: 'calc(100% - 450px)',
        minHeight: 'calc(100% - 450px)',
    },
    orderItemImg: {
        paddingRight: '1rem',
        '@media screen and (max-height: 680px)': {
            flexBasis: '25.6%',
        },
        '&>a': {
            display: 'flex',
            maxWidth: '131px',
            minHeight: '144px',
            '& img': {
                width: '100%',
                height: '100%',
            },
            [theme.breakpoints.down(1366)]: {
                minHeight: 'auto',
            },
            '@media screen and (max-height: 680px)': {
                width: 'auto',
                minHeight: 'auto',
            },
        },

    },
    productContainer: {
        padding: '26px 25px 30px 16px',
        flex: '0 0 auto',
        position: 'relative',
        fontFamily: theme.palette.slideOutMiniCartFont || 'inherit',
        '&::before': {
            content: '""',
            position: 'absolute',
            borderBottom: '1px solid rgba(47, 47, 47, 0.2)',
            width: '94%',
            bottom: '0',
        },
        [theme.breakpoints.down(768)]: {
            padding: '16px 7px 16px 10px ',
        },
        '@media screen and (max-height: 680px)': {
            padding: '13px 25px 15px 16px',
        },
    },
    itemDetailsContainer: {
        '@media screen and (max-height: 680px)': {
            flexGrow: 1,
            maxWidth: '100%',
        },
    },
    viewCartBtn: {
        fontSize: '16px',
        fontWeight: '700 !important',
        margin: 0,
        padding: 0,
        [theme.breakpoints.down(415)]: {
            fontSize: '16px',
        },
        fontFamily: theme.palette.slideOutMiniCartFont || 'inherit',
    },
    borderBottom: {
        borderBottom: '1px solid rgba(47, 47, 47, 0.2)',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px 0px 10px',
        margin: '0rem 1rem',
    },
    container: {
        position: 'fixed',
        top: '0',
        right: '0',
        height: '100%',
        width: '492px',
        zIndex: '11',
        [theme.breakpoints.down(1366)]: {
            width: '461px',
        },
        [theme.breakpoints.down(1024)]: {
            width: '380px',
        },
        [theme.breakpoints.down(415)]: {
            width: '100%',
        },
    },
    cartCount: {
        paddingLeft: '7px',
        fontSize: '20px',
        fontWeight: 400,
    },
    productName: {
        fontSize: '16px',
        margin: 0,
        padding: ' 0px 0px 13px',
        fontWeight: '700 !important',
    },
    btnCheckout: {
        backgroundColor: theme.palette.primaryButton,
        color: theme.palette.common.black,
        fontFamily: theme.palette.slideOutMiniCartFont || 'inherit',
        fontSize: '16px',
        fontWeight: 'bold',
        margin: '20px auto',
        width: '100%',
        minHeight: '50px',
        borderRadius: '0',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.primaryButton,
        },
        '@media screen and (min-width:740px) and (max-width: 1366px)': {
            margin: '10px auto',
        },
        [theme.breakpoints.down(768)]: {
            margin: '5px auto',
        },
    },
    btnContinueShopping: {
        background: 'transparent',
        border: '1pt solid #9d9d9d',
        '&:hover': {
            backgroundColor: '#9d9d9d',
        },
        [theme.breakpoints.down(768)]: {
            marginTop: 20,
        },
    },
    btnCheckoutPlants: {
        backgroundColor: theme.palette.primaryButton,
        color: theme.palette.black,
        fontFamily: theme.palette.slideOutMiniCartFont || 'inherit',
        fontSize: '16px',
        fontWeight: 'bold',
        margin: '20px auto',
        width: '100%',
        minHeight: '50px',
        borderRadius: '0',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.primaryButtonHover,
        },
        '@media screen and (min-width:740px) and (max-width: 1366px)': {
            margin: '10px auto',
        },
        [theme.breakpoints.down(768)]: {
            margin: '5px auto',
        },
    },
    bottomContainer: {
        background: theme.palette.miniCartBg || '#F2F2F2',
        fontFamily: theme.palette.slideOutMiniCartFont || 'inherit',
        padding: '12px 16px 0px',
        '& p': {
            fontSize: '16px',
            lineHeight: '24px',
        },
        '& p:last-child': {
            paddingRight: '12px',
        },

    },
    subtotal: {
        fontFamily: theme.palette.slideOutMiniCartFont || 'inherit',
    },
    priceAttributeContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    closeButton: {
        padding: 0,
        '&:hover': {
            background: 'transparent',
        },
        fontSize: '1rem',
        lineHeight: '1.8rem',
        color: theme.palette?.common?.black,
        '& span': {
            display: 'block',
        },
        '& svg': {
            width: '40px',
            height: '40px',
            fill: theme.palette?.common?.black,
            marginBottom: '-15px',
        },
    },
    flashContainer: {
        position: 'relative',
        background: theme.palette.miniCartBg || '#F2F2F2',
        width: '100%',
    },
    setItemLayout: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        color: theme.palette?.primary?.main || '#2F2F2F',
        fontWeight: '700',
        fontSize: '16px',
    },
    plaCrossedOutRetailPrice: {
        textDecoration: 'line-through',
        color: '#000',
        fontWeight: 700,
    },
    salePrice: {
        fontWeight: '700',
        color: theme.palette.secondary.main,
        fontSize: '16px',
    },
    plaSalePrice: {
        color: theme.palette?.pdp?.salePrice,
        fontWeight: 700,
    },
    defaultPrice: {
        fontWeight: '700',
        fontSize: '16px',
        color: theme.palette?.slideOutMiniCartMainColor || theme.palette?.primary?.main || '#2F2F2F',
    },
    emptyCartContainer: {
        height: 'calc(100% - 70px)',
        overflowY: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
    },
    emptyCartText: {
        fontWeight: 'bold',
        textAlign: 'center',
    },
    emptyCart: {
        marginTop: '70px',
    },
    continueShoppingBtn: {
        padding: '15px 0',
        maxWidth: '300px',
        width: '100%',
        display: 'block',
        textAlign: 'center',
        margin: '0 auto',
        '& a': {
            width: '100%',
        },
    },
    skuCode: {
        fontSize: '12px',
        color: theme.palette.cta4 || '#595959',
        marginBottom: '16px',
        '@media screen and (max-height: 680px)': {
            marginBottom: '4px',
        },
    },
    highLightedBgColor: {
        '&:nth-last-child(2)': {
            backgroundColor: theme.palette.footerLinkImgBg || '#E8F1ED',
        },
    },
    nonStandardItems: {
        display: 'flex',
        justifyContent: 'flex-end',
        '@media screen and (max-height: 680px)': {
            '&>div': {
                flexGrow: 1,
                maxWidth: '75%',
            },
        },
    },
    yourCartCount: {
        fontWeight: '600',
    },
}));

// getting previous state
const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

const SlideOutMiniCart = ({
    closeDrawer, openDrawer, handleCheckout,
}) => {
    const cartCount =  useSelector(getTotalItemInCart);
    const orderTotalProduct =  useSelector(getOrderTotalProduct);
    const orderItems =  useSelector(getCartData);
    const { recipients = [] } = orderItems?.orderDetails?.fdOrderVO || {};
    const classes = useStyles();
    const lastElementRef = useRef();
    const featureFlags =  useSelector(getFeatureFlags);
    const brand = useSelector(getBrand);

    const isPlants = brand.code === 'PLA';

    const splitSkuId = (partNumber) => {
        const skuId = partNumber.match(/[^-_]*$/);
        return (skuId?.length > 0) ? skuId[0] : '';
    };

    useEffect(() => {
        /* eslint-disable no-unused-expressions */
        if (lastElementRef?.current) lastElementRef.current?.scrollIntoView({ scrollBehavior: 'smooth', block: 'end' });
    });

    // set state for the background class
    const [backgroundClass, setBackgroundClass] = useState(false);
    const prevCount = usePrevious(cartCount);

    // set state for the background class
    useEffect(() => {
        if ((prevCount?.cartCount !== cartCount  && cartCount > prevCount) || !prevCount) {
            setBackgroundClass(true);
            setTimeout(() => {
                setBackgroundClass(false);
            }, 5000);
        }
    }, [openDrawer, cartCount]);

    const renderProductName = (productData) => {
        let productName = productData?.parentSkuName || productData?.skuName || '';
        const getCrossBrand = featureFlags?.['which-cross-merch-brands-list'][productData?.brandId];
        if (getCrossBrand &&  getCrossBrand === 'food') {
            productName =  productData?.skuName || productData?.parentSkuName || '';
        }

        return isPlants ? `${productName} - ${productData.skuName}` : productName;
    };

    const isOpen = true;

    return (
        <>
            <Drawer
                anchor="right"
                open={openDrawer}
                onClose={() => closeDrawer()}
                classes={{ paper: classes.containerDrawer, modal: classes.modalDrawer }}
            >
                <Grid container className={`SlideOutMiniCart ${classes.container}`}>
                    <Grid item xs={12} className={`${classes.header} ${classes.borderBottom}`}>
                        <h4 className={classes.viewCartBtn}>
                            1 Item Added To Your Cart
                        </h4>
                        <IconButton  className={classes.closeButton} aria-label="close" onClick={() => closeDrawer()} disableRipple>
                            <CloseIcon />
                            <span>Close</span>
                        </IconButton>
                    </Grid>
                    {cartCount > 0
                        ? (
                            <>
                                <Grid item xs={12}   className={`${classes.list} ${isOpen ? classes.listContainer : ''}`}>
                                    { Object.keys(recipients).map(
                                        (key) => (recipients[key].orderItems.map(
                                            (orderItem) => (
                                                <Grid container key={`productList-${key}${1}`} className={`${classes.productContainer} ${backgroundClass ? classes.highLightedBgColor : ''}`}>
                                                    <Grid item xs={4} className={classes.orderItemImg}>
                                                        <Link to={orderItem.catalogEntryVO?.productSEOUrl || '/'}>
                                                            <ItemImage
                                                                imagePath={orderItem.catalogEntryVO?.imagePath || ''}
                                                                imageName={orderItem.catalogEntryVO?.flowersImgName || ''}
                                                                typeImg="c"
                                                                size="?width=100&height=109"
                                                            />
                                                        </Link>
                                                    </Grid>
                                                    <Grid xs={8} item className={classes.itemDetailsContainer}>
                                                        <Grid className={classes.orderItemDetails} container>
                                                            {/* Product Details Start */}
                                                            <Grid item xs={10}><h6 className={classes.productName}>{ReactHtmlParser(renderProductName(orderItem.catalogEntryVO))}</h6></Grid>
                                                            <Grid item xs={2}>
                                                                <DeleteItemButton
                                                                    orderItemId={orderItem?.orderItemsId}
                                                                    pageProcess="checkout-food"
                                                                    skuCode={orderItem?.catalogEntryVO.skuCode}
                                                                    parentSkuCode={orderItem?.catalogEntryVO?.parentSkuCode}
                                                                    isSlideOutMiniCart
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} className={classes.skuCode}>Item#: <span>{splitSkuId(orderItem.catalogEntryVO?.skuCode || '')}</span></Grid>
                                                            <Grid item xs={9}>Qty: <span>{orderItem.catalogEntryVO?.quantity}</span></Grid>
                                                            <Grid item xs={3}>
                                                                <span className={classes.setItemLayout}>
                                                                    { orderItem.catalogEntryVO?.skuListPrice !== orderItem.catalogEntryVO?.skuOfferPrice
                                                                        ? (
                                                                            <>
                                                                                <span className={isPlants ? classes.plaSalePrice : classes.crossedOutRetailPrice}>
                                                                                    ${isPlants ? orderItem.catalogEntryVO?.skuOfferPrice : orderItem.catalogEntryVO?.skuListPrice}
                                                                                </span>
                                                                                <span className={isPlants ? classes.plaCrossedOutRetailPrice : classes.salePrice}>
                                                                                    ${isPlants ? orderItem.catalogEntryVO?.skuListPrice : orderItem.catalogEntryVO?.skuOfferPrice}
                                                                                </span>
                                                                            </>
                                                                        )
                                                                        : <span className={classes.defaultPrice}> ${orderItem.catalogEntryVO?.skuListPrice}</span>}
                                                                </span>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            ))))}
                                    {/* getting this last element with scroll */}
                                    <span ref={lastElementRef} />
                                </Grid>
                                <Grid item xs={12} className={`${classes.bottomContainer}`}>
                                    <div className={classes.yourCartCount}>Your Cart: {cartCount} items</div>
                                    <hr />
                                    <div className={classes.priceAttributeContainer}>
                                        <div className={classes.subtotal}>
                                            Order Subtotal:
                                        </div>
                                        <div className={classes.subtotal}>
                                            {`$${(setCurrencyFormatforTotalOrder(Number(orderTotalProduct || 0).toFixed(2)))}`}
                                        </div>
                                    </div>
                                    <div className={classes.priceAttributeContainer}>
                                        <div className={classes.subtotal}>
                                            Est. Shipping + Handling:
                                        </div>
                                        <div className={classes.subtotal}>
                                            TBD
                                        </div>
                                    </div>
                                    <div className={classes.priceAttributeContainer}>
                                        <div className={classes.subtotal}>
                                            Subtotal:
                                        </div>
                                        <div className={classes.subtotal}>
                                            {`$${(setCurrencyFormatforTotalOrder(Number(orderTotalProduct || 0).toFixed(2)))}`}
                                        </div>
                                    </div>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Button
                                                color="primary"
                                                className={`${classes.btnCheckout} ${classes.btnContinueShopping}`}
                                                onClick={(event) => handleCheckout('home', event)}
                                            >
                                                Continue Shopping
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Button
                                                color="primary"
                                                className={isPlants ? classes.btnCheckoutPlants : classes.btnCheckout}
                                                onClick={(event) => handleCheckout('checkout', event)}
                                            >
                                                Checkout
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        ) : (
                            <Grid container className={classes.emptyCartContainer}>
                                <Grid item xs={12} className={classes.emptyCart}>
                                    <Typography data-test="mini-cart-header-text" variant="h6" className={classes.emptyCartText}>
                                        Your cart is currently empty.
                                    </Typography>
                                    <div className={classes.continueShoppingBtn}>
                                        <ContinueShoppingButton />
                                    </div>
                                </Grid>
                            </Grid>
                        )}
                </Grid>
            </Drawer>
        </>
    );
};

SlideOutMiniCart.propTypes = {
    openDrawer: bool.isRequired,
    closeDrawer: func.isRequired,
    handleCheckout: func.isRequired,
};

export default SlideOutMiniCart;
